import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles';
import ScheduleMobileHeader from './components/ScheduleMobileHeader/ScheduleMobileHeader';
import { Grid, Tabs, Tab, Divider } from '@material-ui/core';
import MySchedule from './components/MySchedule/MySchedule';
import Resource from './components/Resource/Resource';
import CarouselCalendar from 'components/CarouselCalendar/CarouselCalendar';
import { useDispatch, useSelector } from 'react-redux';
import { format, parse } from 'date-fns';
import useHasEditAccess from '../../hooks/useHasEditAccess';
import { updateSelectedDate } from 'store/schedule/schedulePageOperation';
import Header from './components/MySchedule/components/Header/Header';

const TABS = [
  {
    index: 0,
    name: 'schedule',
    label: 'Schedule',
  },
  {
    index: 1,
    name: 'resources',
    label: 'Resources',
  },
];

const AdminMobileSchedulePage = ({
  classes,
  openDrawer,
  openSnackbar,
  showPublishModal,
  showUpdateModal,
  canPublish,
  canUpdate,
  showReconcileModal,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const { hasEditAccess } = useHasEditAccess();
  const selectedDate = useSelector((state) => state.schedule.selectedDate);
  const [activeTab, setActiveTab] = useState(TABS[0]);

  const onDateSelected = (date) => {
    if (date) {
      const arr = location.pathname.split('/').filter((p) => !!p);
      if (/(\d{4}-\d{2}-\d{2})$/.test(location.pathname)) arr[arr.length - 1] = format(date, 'yyyy-MM-dd');
      else arr.push(format(date, 'yyyy-MM-dd'));
      navigate('/' + arr.filter((p) => !!p).join('/'));
    }
  };

  const effectiveSelectedDate = useMemo(
      () => (params.date ? parse(params.date, 'yyyy-MM-dd', new Date()) : selectedDate),
      [params.date, selectedDate]
    );

  useEffect(() => {
    if (params.date) dispatch(updateSelectedDate(parse(params.date, 'yyyy-MM-dd', new Date())));
  }, [params.date, dispatch]);

  return (
    <>
      <ScheduleMobileHeader />
      <Header
        openDrawer={openDrawer}
        showPublishModal={showPublishModal}
        showUpdateModal={showUpdateModal}
        canPublish={canPublish}
        canUpdate={canUpdate}
        showReconcileModal={showReconcileModal}
        hasEditAccess={hasEditAccess}
        selectedDate={effectiveSelectedDate}
      />
      <Grid
        container
        justifyContent={'center'}
        style={{ fontSize: 20, height: 60, margin: '20px 0' }}
      >
        <CarouselCalendar selectedDate={selectedDate} onDateSelected={onDateSelected} />
      </Grid>

      <Tabs
        value={activeTab.index}
        onChange={(_, newValue) => setActiveTab(TABS.find((t) => t.index === newValue))}
        className={classes.tabs}
      >
        {TABS.map((tab) => (
          <Tab
            key={tab.index}
            label={tab.label}
            href={tab.href}
            disableRipple
            component="a"
            onClick={(event) => event.preventDefault()}
          />
        ))}
      </Tabs>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      {activeTab.index === 0 && (
        <MySchedule
          hasEditAccess={hasEditAccess}
          openSnackbar={openSnackbar}
          openDrawer={openDrawer}
          selectedDate={effectiveSelectedDate}
        />
      )}
      {activeTab.index === 1 && <Resource hasEditAccess={hasEditAccess} openSnackbar={openSnackbar} />}
    </>
  );
};

export default withStyles(styles)(AdminMobileSchedulePage);
